import React from 'react';
import Container from "../../Wrappers/Container";
import CarouselGrid from "../../Wrappers/CarouselGrid";
import PeriodPayrollItem from "../../Molecules/Items/PeriodPayrollItem";

const PeriodPayroll = () => {
  return (
    <Container className="lg-cols-3">
      <h3>Períodos</h3>
      <CarouselGrid
        breakpoints={{
          lg: 3,
          m: 3,
          s: 2,
        }}
      >
        <PeriodPayrollItem
          title="Nómina quincenal"
          icon="document"
          content="Del 1 al 15"
        />

        <PeriodPayrollItem
          title="Nómina quincenal"
          icon="lock"
          content="Del 15 al 31"
          isLocked
        />

        <PeriodPayrollItem
          title="Nómina mensual"
          icon="document"
          content="Del 1 al 31"
          isSolved
        />
      </CarouselGrid>
    </Container>
  );
};

export default PeriodPayroll;
